import { Typography } from 'antd';
import { ReactComponent as CheckIcon } from 'assets/icons/Check.svg';
import { ReactComponent as ChevronStepsSeparator } from 'assets/icons/ChevronStepsSeparator.svg';
import cx from 'clsx';
import React from 'react';

type Step = {
  key: number;
  title: string;
};

export function ChevronSteps({
  currentStep = 0,
  steps,
}: {
  currentStep: number; // 0-based
  steps: Step[];
}) {
  return (
    <div className="flex h-16 items-center">
      {steps.map((s, idx) => {
        const isActive = idx === currentStep;
        const isDone = idx < currentStep;

        return (
          <React.Fragment key={s.key}>
            <div
              className={cx('flex h-full items-center gap-2', 'px-2')}
              aria-current={isActive ? 'step' : undefined}
            >
              <span
                className={cx(
                  'flex h-8 w-8 items-center justify-center rounded-full text-sm leading-[22px] font-normal',
                  isActive
                    ? 'bg-bleu-hellio-500 text-white'
                    : isDone
                      ? ''
                      : 'bg-gris-industriels-6 text-white',
                )}
              >
                {isDone ? (
                  <CheckIcon className="h-8 w-8 rounded-full bg-bleu-clair-hellio p-2 text-bleu-hellio" />
                ) : (
                  idx + 1
                )}
              </span>

              <Typography.Text
                className={cx(
                  '!m-0 !text-sm !leading-6',
                  isActive
                    ? 'text-bleu-hellio-500 font-semibold'
                    : isDone
                      ? 'text-bleu-hellio-500 font-semibold'
                      : 'text-gris-industriels-6 font-normal',
                )}
              >
                {s.title}
              </Typography.Text>
            </div>

            {idx !== steps.length - 1 && (
              <div className="flex h-full items-center px-2">
                <ChevronStepsSeparator
                  aria-hidden="true"
                  className="text-color-border"
                />
              </div>
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
}
